// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3AU5T","desabilitar":"OptionSelect_desabilitar__1ha32","focado":"OptionSelect_focado__3UNXc","novo":"OptionSelect_novo__10C4K"};